module.exports = __webpack_public_path__ + "img/arrow-right.a1689db6.svg";